"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAddition = exports.$add = exports.$ADD = void 0;
const isObject_js_1 = require("../../../../utils/validation/isObject.js");
const isExtension_js_1 = require("./isExtension.js");
exports.$ADD = Symbol('$ADD');
const $add = (value) => ({ [isExtension_js_1.$IS_EXTENSION]: true, [exports.$ADD]: value });
exports.$add = $add;
const isAddition = (input) => (0, isObject_js_1.isObject)(input) && exports.$ADD in input;
exports.isAddition = isAddition;
